import wishApi from '../apis/wish'
import { BASE_WISH_YEAR, WISH_TYPE } from '@/tools/constant'

const state = {
  wishAdoptedCount: 0,
  wishUnAdoptedCount: 0,
  wishList: [
    {
      type: WISH_TYPE.WISH,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      loading: false,
      data: []
    },
    {
      type: WISH_TYPE.READING,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      loading: false,
      data: []
    }
  ],
  readingList: {
    currentPage: 0,
    lastPage: 1,
    total: 0,
    loading: false,
    data: []
  },
  wishItem: {},
  commentsList: [],
  userWishList: [],
  myUserWishes: {
    userId: '',
    data: [],
    currentPage: 1,
    lastPage: 1,
    total: 0,
    loading: false,
    sections: []
  },
  otherUserWishes: {
    userId: '',
    data: [],
    currentPage: 1,
    lastPage: 1,
    total: 0,
    loading: false,
    sections: []
  },
  wishPreTime: '',
  wishStartTime: '',
  wishEndTime: '',
  filter: {
    year: '',
    school: '',
    status: '',
    organizerId: '',
    wishNo: '',
    keyword: ''
  },
  schoolList: {
    data: [],
    year: '',
    organizerId: ''
  },
  wishConfig: {
    data: [],
    organizerId: ''
  }
}

const actions = {
  getWishList ({commit, state}, {page, status, batch, schoolName, type, organizerId, wishNo, keyword, cb}) {
    commit('setWishListLoading', { loading: true, type })
    wishApi.getWishList({
      page,
      status,
      batch,
      schoolName,
      type,
      organizerId,
      wishNo,
      keyword,
      cb: (data) => {
        commit('setWishList', { data, type, organizerId })
        cb(data)
      }
    })
  },
  getWishItem ({ commit, state }, { id, cb }) {
    wishApi.getWishItem(
      id,
      (data) => {
        commit('setWishItem', { data })
        cb && cb(data)
      }
    )
  },
  getCommentsList ({ commit, state }, { id, cb }) {
    wishApi.getCommentsList(
      id,
      (data) => {
        commit('setCommentsList', { data })
        cb(data)
      }
    )
  },
  submitComments ({ commit, state }, {data, cb}) {
    wishApi.submitComments(
      data,
      (data) => cb(data)
    )
  },
  donate ({ commit, state }, {id, data, cb}) {
    wishApi.donate(
      id,
      data,
      (data) => cb(data)
    )
  },
  voteUp ({ commit, state }, { id, cb }) {
    wishApi.voteUp(id, (data) => cb(data))
  },
  cancelVote ({ commit, state }, { id, cb }) {
    wishApi.cancelVote(id, (data) => cb(data))
  },
  sendRead ({ commit, state }, { id }) {
    wishApi.sendRead(id)
  },
  getUserWishList ({ commit, state }, { id, cb, isSelf, page, perPage }) {
    commit('setUserWishLoading', { loading: true, isSelf })
    wishApi.getUserWishList(id, '', data => {
      commit('setUserWishList', { userId: id, data, isSelf })
      cb(data)
    }, page, perPage)
  },
  getWishCount ({ commit }, { batch, schoolName, organizerId }) {
    return wishApi.getWishCount({ batch, schoolName, organizerId })
      .then(data => {
        commit('setWishCount', data)
      })
      .catch(err => {
        console.log(err)
      })
  },
  getWishTimes ({ commit }) {
    let batch = new Date().getFullYear() - BASE_WISH_YEAR
    return wishApi.getWishTimes(batch)
      .then(data => {
        commit('setWishTimes', data)
      })
      .catch(err => {
        console.log(err)
      })
  },
  traceWishItem ({ commit }, { id }) {
    return wishApi.traceWish(id)
      .then(data => {
        commit('setWishTracing', data)
      })
      .catch(err => {
        console.log(err)
      })
  },
  getSchools ({ commit }, { year, organizerId }) {
    let batch = ''
    if (year) {
      batch = year - BASE_WISH_YEAR
    }
    return wishApi.getSchools({ batch, organizerId })
      .then(data => {
        commit('setSchoolList', { data, year, organizerId })
      })
  },
  getWishConfigs ({ commit }, { organizerId }) {
    return wishApi.getWishConfigs({ organizerId })
      .then(data => {
        commit('setWishConfigs', { data, organizerId })
      })
  }
}

const mutations = {
  setWishList (state, { data, type, organizerId }) {
    state.wishList = state.wishList.map(wishes => {
      if (type === wishes.type) {
        return {
          ...wishes,
          organizerId,
          currentPage: data.current_page,
          lastPage: data.last_page,
          total: data.total,
          loading: false,
          data: data.current_page === 1 ? data.data : [
            ...wishes.data,
            ...data.data
          ]
        }
      }

      return wishes
    })
  },
  setDonateStatus (state, { id, type }) {
    const wish = state.wishList[type].data.find(item => item.id === id)
    if (wish) {
      wish.status = 'end'

      state.wishAdoptedCount++
      state.wishUnAdoptedCount = state.wishUnAdoptedCount - 1 > 0 ? state.wishUnAdoptedCount - 1 : 0
    }
  },
  setWishItem (state, { data }) {
    state.wishItem = data
  },
  clearWishList (state) {
    state.wishList = state.wishList.map(wishes => {
      return {
        type: wishes.type,
        currentPage: 0,
        lastPage: 1,
        total: 0,
        loading: false,
        data: []
      }
    })
  },
  setCommentsList (state, { data }) {
    state.commentsList = data
  },
  setUserWishLoading (state, { loading, isSelf }) {
    const prefix = isSelf ? 'my' : 'other'
    state[`${prefix}UserWishes`] = {
      ...state[`${prefix}UserWishes`],
      loading: true
    }
  },
  setUserWishList (state, { userId, data, isSelf }) {
    const prefix = isSelf ? 'my' : 'other'
    state[`${prefix}UserWishes`] = {
      userId,
      data: data.current_page === 1 ? data.data : [
        ...state[`${prefix}UserWishes`].data,
        ...data.data
      ],
      currentPage: data.current_page + 1,
      total: data.total,
      lastPage: data.last_page,
      loading: false,
      sections: []
    }
  },
  setWishCount (state, data) {
    state.wishAdoptedCount = data.adopted_count
    state.wishUnAdoptedCount = data.unadopted_count
  },
  setWishTimes (state, data) {
    state.wishPreTime = data && data.pre_time && data.pre_time.replace(/-/g, '/')
    state.wishStartTime = data && data.start_time && data.start_time.replace(/-/g, '/')
    state.wishEndTime = data && data.end_time && data.end_time.replace(/-/g, '/')
  },
  setWishTracing (state, data) {
    state.wishItem = {
      ...state.wishItem,
      is_tracing: data.is_tracing
    }
  },
  setWishFilter (state, filter) {
    state.filter = {
      ...state.filter,
      ...filter
    }
  },
  setWishListLoading (state, { loading, type }) {
    state.wishList = state.wishList.map(wishes => {
      if (type === wishes.type) {
        return {
          ...wishes,
          loading
        }
      }

      return wishes
    })
  },
  setSchoolList (state, { data, year, organizerId }) {
    state.schoolList = {
      data,
      year,
      organizerId
    }
  },
  setWishConfigs (state, { data, organizerId }) {
    state.wishConfig = {
      data,
      organizerId
    }
  }
}

const getters = {
  schoolMap (state) {
    const map = {}
    ;(state.schoolList.data || []).forEach(school => {
      if (school.name) {
        map[school.name] = school.title || school.name
      }
    })
    return map
  },
  wishConfigYears (state) {
    const map = {}
    ;(state.wishConfig.data || []).forEach(config => {
      map[config.batch + BASE_WISH_YEAR] = {
        banner: config.wish_banner,
        link: config.wish_link,
        readingBanner: config.reading_banner,
        readingLink: config.reading_link,
        videoUrl: config.video_url
      }
    })
    return map
  }
}

export default{
  state,
  actions,
  mutations,
  getters
}
